import { Module } from 'vuex'
import { RootState } from '@/store'
import { mutations } from '@/store/modules/event/mutations'
import { IEventState, initialState } from '@/store/modules/event/state'

export * from '@/store/modules/event/state'

export const store: Module<IEventState, RootState> = {
  state: initialState,
  mutations
}
